import Rebase from "re-base";
import firebase from "firebase";

const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyB_yGTIqwN_2zy8Yi5XgpC3exVLfEO26rM",
    authDomain: "personalwebsite-b1568.firebaseapp.com",
    databaseURL: "https://personalwebsite-b1568.firebaseio.com"
});

const base = Rebase.createClass(firebaseApp.database());

export {firebaseApp};

export default base;
